import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { BringzzText } from "@bringzz/components";

function TextMessage(props) {
    const message = props.message;
    const isSender = props.isSender;
    const hasPrevious = props.hasPrevious;
    const isPending = props.isPending;
    const isRead = props.isRead;
    const onPharmacyClick = props.onPharmacyClick;
    const initials = props.initials;

    const background = isSender ?
        "bg-sand/50 rounded-tl-3xl rounded-tr-3xl rounded-bl-3xl"
        : "bg-magic-lilac/50 rounded-tl-3xl rounded-tr-3xl rounded-br-3xl";

    const handleClick = () => {
        if (!isSender && onPharmacyClick) {
            onPharmacyClick();
        }
    };

    return (
        <div>
            <div className={isSender ? "flex flex-row-reverse items-end space-x-4 !space-x-reverse" : "flex items-end space-x-4"}>
                <div className={classNames(
                    "w-10 h-10 rounded-full flex justify-center items-center",
                    isSender ? "bg-sand/50" : "bg-magic-lilac/50",
                    hasPrevious && "hidden"
                )}>
                    <BringzzText tag="h2" className='text-midnight-blue'>{initials}</BringzzText>
                </div>
                <div
                    className={classNames(
                        "p-4 text-gray-50 max-w-xs lg:max-w-xl",
                        !isSender && onPharmacyClick && "cursor-pointer",
                        background
                    )}
                    onClick={handleClick}
                >
                    <BringzzText tag="h4" className="font-normal min-w-4 text-sm whitespace-pre-line break-words text-midnight-blue">
                        {message.text}
                    </BringzzText>

                    {/* Time and status inside message bubble */}
                    <div className={classNames(
                        "flex items-center space-x-1 mt-2",
                        isSender ? "justify-end" : "justify-start"
                    )}>
                        <BringzzText tag="h6" className="text-xs text-midnight-blue/60">
                            {message.date ? message.date.split(' ')[1]?.substring(0, 5) || 'Now' : 'Now'}
                        </BringzzText>

                        {/* Status indicators for sender only */}
                        {isSender && (
                            <div className="flex items-center space-x-1">
                                {isPending ? (
                                    <span className="text-xs text-midnight-blue/60">⏳</span>
                                ) : (
                                    <span className="text-xs text-midnight-blue/60">✓</span>
                                )}

                                {!isPending && isRead && (
                                    <span className="text-xs text-blue-600">✓</span>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TextMessage;
